import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { LegalScreen, documentForPath } from '@/features/legal/LegalScreen';
import { AdInterstitial, AdRails } from './components/ad-slot';
import { isTelegramMode } from './shared/app-mode';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Данные чата приходят по сокету, поэтому фоновые перезапросы не нужны.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Не найден корневой элемент #root');
}

/*
  Правила и политика — отдельные адреса, а не окно поверх приложения: на них
  ссылается бот и присылают в поддержке, а ссылку на всплывающее окно передать
  нельзя. Роутер ради двух страниц не нужен — достаточно посмотреть на адрес.
*/
const legalDocument = documentForPath(window.location.pathname);

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {legalDocument ? (
        <div className="web-frame">
          <LegalScreen document={legalDocument} />
        </div>
      ) : (
        <>
      {/*
        Узкая колонка — только для мини-приложения: в Telegram оно всегда живёт
        в окне шириной около 420 px. Веб-версия занимает страницу целиком и
        адаптируется под ширину экрана.
      */}
      <div className={isTelegramMode ? 'webapp-frame' : 'web-frame'}>
        <App />
      </div>

      {/*
        Боковые рекламные места — только в вебе: окно мини-приложения узкое, и
        свободного поля по краям там нет. Стоят рядом с рамкой, а не внутри
        экранов, поэтому видны на всех: и на главной, и в анкете, и в диалоге.
      */}
      {isTelegramMode ? null : <AdRails />}

      {/*
        Всплывающий баннер — поверх всего и на обеих поверхностях: в
        мини-приложении он тоже уместен, если в панели задан код.
      */}
      <AdInterstitial />
        </>
      )}
    </QueryClientProvider>
  </StrictMode>,
);
